export default defineNuxtPlugin((NuxtApp) => {
  return {
    provide: {
      getAvatarImage(number) {
        return `/avatars/avatar${number || 0}.jpg`;
      }
    }
  }
});
